export const getTaskListSortingField = state =>
  state.persistedUserInterface.taskListSortingField;
export const getTaskListStatusFilter = state =>
  state.persistedUserInterface.taskListStatusFilter;
